export default __webpack_public_path__ + "static/media/icon-history.72a36275.svg";